import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiClientService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  protected getUrl(path: string): string {
    return `${this.baseUrl}${path}`;
  }

  protected get<T>(path: string) {
    return this.http.get<T>(this.getUrl(path));
  }

  protected getText(path: string) {
    return this.http.get(this.getUrl(path), { responseType: 'text' });
  }

  protected post<T>(path: string, body: unknown) {
    return this.http.post<T>(this.getUrl(path), body);
  }

  protected put<T>(path: string, body: unknown) {
    return this.http.put<T>(this.getUrl(path), body);
  }

  protected delete<T>(path: string) {
    return this.http.delete<T>(this.getUrl(path));
  }
}
